export default __webpack_public_path__ + "static/media/indra_nooyi.b59bc8d5.png";